import { useEffect, useMemo } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { loadStripeWrapper } from "@/react/hooks/paywalls/useStripeElement";
import { stripeElementsOptions as appearanceStripeElementOptions } from "../../StripeElements/stripeElementsOptions";
import type { StripeElementsManagerProps } from "./Props";
import { useOptions } from "./useOptions";

export const ManagerWithPMC = ({ children }: StripeElementsManagerProps) => {
  const { processorId, processorKey, setStripeElementsMode } =
    usePaywallCheckoutContext();

  const stripe = useMemo(
    () =>
      loadStripeWrapper({
        stripeAccountId: processorId,
        stripePublicKey: processorKey,
        // TODO: should we use the community's locale instead?
        locale: window.locale,
      }),
    [processorId, processorKey],
  );
  const options = useOptions();
  const stripeElementsMode = options.mode;

  useEffect(() => {
    setStripeElementsMode(stripeElementsMode);
  }, [setStripeElementsMode, stripeElementsMode]);

  return (
    <Elements
      stripe={stripe}
      options={{
        ...appearanceStripeElementOptions,
        ...options,
      }}
    >
      {children}
    </Elements>
  );
};
